import { Expensable } from 'modules/expenses/types/Expensable'

interface Props {
  expensable?: Expensable
}

export const useExpensableJournalEntries = ({ expensable }: Props) => {
  const expense = expensable?.expense

  if (!expense) return { journalDraftEntry: null, journalEntry: null }

  if (expense.documentType === 'invoice') {
    return {
      journalDraftEntry:
        expense.financialDocumentAssociation?.financialDocument?.journalDraftEntry || null,
      journalEntry: expense.financialDocumentAssociation?.financialDocument?.journalEntry || null,
    }
  } else {
    return {
      journalDraftEntry: expense.journalDraftEntry || null,
      journalEntry: expense.journalEntry || null,
    }
  }
}
